import React, { useEffect, useState } from "react";
import "./Login_main.css";
import Form from "react-bootstrap/Form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import { AuthLogin } from "../../features/auth/Slice";
import classNames from "classnames";
import Successful_toaster from "../common-components/toaster/Successful_toaster";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

const Login = () => {
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [success, setSuccess] = useState(false);
  const [err, setErr] = useState(false);
  const [message, setMessage] = useState("");
  const [show, setShow] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
  } = useForm({});

  const navigate = useNavigate();

  const onSubmit = async (data) => {
    try {
      const result = await dispatch(AuthLogin(data));

      if (result.payload.data?.success) {
        setSuccess(true);
        Cookies.set("pmroad_admin_security", result.payload.data.data?.token, {
          expires: 365,
        });
        setShow(true);

        setTimeout(() => {
          setShow(false);
          navigate("/");
        }, 2000);
      } else {
        console.log(result, "llllllllllll");

        if (result.payload.errors.email) {
          await setError("email", {
            type: "manual",
            message: result.payload.errors.email?.msg,
          });
        }
        if (result.payload.errors.password) {
          await setError("password", {
            type: "manual",
            message: result.payload.errors.password?.msg,
          });
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (auth.isLogin) {
      // navigate("/dashboard");
    }
  }, [auth]);

  const [showPassword, setShowPassword] = useState(false);

  const togglePassword = () => {
    setShowPassword((prev) => !prev);
  };

  return (
    <>
      <div className="container-fluid p-0">
        <div className="Login_main_section">
          <div className="container">
            <div className="row">
              <div className="col-xl-9 col-lg-10 mx-auto">
                <div className="form-bg-img ">
                  <div className="row w-100 justify-content-center">
                    <div className="col-md-6">
                      <div className="login_form_sec">
                        <img
                          className="lockicn"
                          src={
                            process.env.PUBLIC_URL +
                            "/assets/images/login/lock.png"
                          }
                        />
                        <h3 className="logintitle">Login</h3>
                        <Form onSubmit={handleSubmit(onSubmit)}>
                          <Form.Group className="mb-3">
                            <Form.Label>Email ID</Form.Label>
                            <Form.Control
                              type="email"
                              placeholder="Enter Email ID"
                              className={classNames("", {
                                "is-invalid": errors?.email,
                              })}
                              {...register("email", {
                                required: "Email ID is required",
                                pattern: {
                                  value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                                  message: "Enter a valid email address",
                                },
                              })}
                            />
                            {errors?.email && (
                              <Form.Text className="text-danger">
                                {errors?.email?.message}
                              </Form.Text>
                            )}
                          </Form.Group>

                          <Form.Group>
                            <Form.Label>Password</Form.Label>
                            <div className="password_holder">
                              <Form.Control
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter Password"
                                className={classNames("", {
                                  "is-invalid": errors?.password,
                                })}
                                {...register("password", {
                                  required: "Password is required",
                                })}
                              />

                              <div
                                className="eye_icon_div"
                                onClick={togglePassword}
                              >
                                <FontAwesomeIcon
                                  icon={showPassword ? faEyeSlash : faEye}
                                />
                              </div>
                            </div>

                            {errors?.password && (
                              <Form.Text className="text-danger">
                                {errors?.password?.message}
                              </Form.Text>
                            )}
                            {message && (
                              <Form.Text className="text-danger">
                                {message}
                              </Form.Text>
                            )}
                          </Form.Group>
                          {err && (
                            <div className="alert alert-danger">{err}</div>
                          )}

                          <Form.Group className="mb-3">
                            <button
                              className="submitbtn"
                              onClick={handleSubmit(onSubmit)}
                            >
                              Submit
                            </button>
                          </Form.Group>
                        </Form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Successful_toaster
        show={show}
        onClose={() => setShow(false)}
        message={"Successfully Loged-In"}
      />
    </>
  );
};

export default Login;
